var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1377 920",
    style: {
      enableBackground: "new 0 0 1377 920"
    },
    fill: "none",
    preserveAspectRatio: "none",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1364.39 413.454C1371.42 406.814 1385.48 382.895 1370.04 380.235C1354.6 377.575 1312.52 446.562 1297.78 436.611C1283.05 426.66 1360.22 312.587 1327.25 297.335C1307.19 288.054 1286.12 302.395 1266.17 315.303C1243.77 329.774 1223.6 342.719 1224.08 323.952C1224.31 314.708 1287.24 255.077 1233.22 219.253C1203.28 199.389 1148.44 229.279 1095.96 258.183C1053.78 281.414 1009.29 311.044 965.991 285.711C901.881 248.213 917.953 3.08653 731.505 -4L-21 -4V792.89C-21 792.89 227.622 939.01 442.712 917.918C657.801 896.826 867.121 670.373 894.661 651.848C935.834 624.153 972.345 636.038 953.224 675.209C934.103 714.38 963.807 747.823 1021.86 711.553C1127.1 645.803 1208.65 367.327 1289.15 348.485C1307.7 344.133 1236.41 469.328 1284.55 467.17C1306.07 466.203 1355.36 398.89 1360.42 395.431C1378.99 382.727 1361.86 412.45 1361.86 412.45L1364.43 413.417L1364.39 413.454Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryBackground);
export default __webpack_public_path__ + "static/media/gallery-background.4b02e65e54b9fe896439da812e8b3d9a.svg";
export { ForwardRef as ReactComponent };